import React, { useMemo, useState } from "react";
import useAuth from "../../../../Hooks/useAuth";
import usePermission from "../../../../Hooks/usePermission";
import { useGetEndUsersByFirmQuery, useGetEmployeeTemplatesQuery } from "../../../../store";
import { EmptyState } from "../../../shared";
import {
  ALL_TEMPLATES,
  countByTemplate,
  templateFilterFor,
  employeeTemplateId,
} from "../../../../utils/templateGrouping";
import EmployeesTab from "../EmployeesTab";
import EmployeeTemplatesTab from "./EmployeeTemplatesTab";

/**
 * ÇALIŞANLAR + ÇALIŞAN ŞABLONLARI tek sekmede (#298, yalnız merkez paneli —
 * #362). Solda şablon sütunu (kişi sayılarıyla), sağda çalışan listesi;
 * şablona tıklamak listeyi süzer. Sütun `firms.employeeTemplatesRead`,
 * liste `firms.employees` ister.
 */
export default function EmployeesWithTemplatesTab({ firm, readOnly }) {
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  const canEmployees = hasPermission("firms.employees");
  const canTemplates = hasPermission("firms.employeeTemplatesRead");
  const [selectedId, setSelectedId] = useState(ALL_TEMPLATES);

  // EmployeesTab ile aynı argüman ve seçenekler — RTK Query tek istek atar.
  const { data: endUsersData } = useGetEndUsersByFirmQuery(
    { token: auth?.accessToken, firmId: firm?._id },
    { skip: !auth?.accessToken || !firm?._id || !canEmployees, refetchOnMountOrArgChange: true }
  );
  const endUsers = useMemo(() => endUsersData?.data || [], [endUsersData]);

  const { data: templatesRes } = useGetEmployeeTemplatesQuery(
    { token: auth.accessToken, id: firm?._id },
    { skip: !firm?._id || !canTemplates }
  );
  const templates = useMemo(() => templatesRes?.data?.templates || [], [templatesRes]);

  const stats = useMemo(
    () => countByTemplate(endUsers, templates, employeeTemplateId),
    [endUsers, templates]
  );
  const extraFilter = useMemo(
    () => (selectedId === ALL_TEMPLATES ? undefined : templateFilterFor(selectedId, templates, employeeTemplateId)),
    [selectedId, templates]
  );

  return (
    <div className="flex flex-col md:flex-row h-full min-h-0">
      {canTemplates && (
        <EmployeeTemplatesTab
          firm={firm}
          readOnly={readOnly}
          selectedId={selectedId}
          onSelect={setSelectedId}
          stats={stats}
        />
      )}
      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        {canEmployees ? (
          <EmployeesTab firm={firm} readOnly={readOnly} extraFilter={extraFilter} />
        ) : (
          <EmptyState
            message="Çalışan listesini görme yetkiniz yok"
            suggestion="Şablonları soldan yönetebilirsiniz."
          />
        )}
      </div>
    </div>
  );
}
